import type { RootState } from '..';
import type { ContainerViewModel } from '../types';

export const getContainerViewModels = (state: RootState): Record<string, ContainerViewModel> => state.container.byId;
